export function initTaxReturnObject(dossier_id) {
    return (
        {
            id: null,
            fiscal_closing_date: null,
            fiscal_starting_date: null,
            dossier_id: dossier_id,
            data: {
                a1a2_1329: 0,
                a3_1330: 0,
                fs_2052: 0,
                fu_2052: 0,
                fw_2052: 0,
                a4_2053: 0,
                gr_2052: 0,
                gt_2052: 0,
                es_2058: 0
            }
        }
    )
}

export function buildTaxReturnFormDataBuilder(taxReturn) {    
    const formData = new FormData();

    if (taxReturn.id) {
        formData.append('tax_return[id]', taxReturn.id);
    }

    formData.append('tax_return[dossier_id]', taxReturn.dossier_id);
    formData.append('tax_return[data]', JSON.stringify(taxReturn.data));
    formData.append('tax_return[fiscal_closing_date]', taxReturn.fiscal_closing_date);
    formData.append('tax_return[fiscal_starting_date]', taxReturn.fiscal_starting_date);
    
    if (taxReturn.status)
        formData.append('tax_return[status]', taxReturn.status);

    return formData;
}
